import { render, staticRenderFns } from "./AtencionAnamnesis.vue?vue&type=template&id=5b23ee8c"
import script from "./AtencionAnamnesis.vue?vue&type=script&lang=js"
export * from "./AtencionAnamnesis.vue?vue&type=script&lang=js"
import style0 from "./AtencionAnamnesis.vue?vue&type=style&index=0&id=5b23ee8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports